export default __webpack_public_path__ + "static/jemielity-f40802eec2530c21c77668f8a32265e0.jpg";